import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

const BannerSlider = () => {
  const slides = [
    { id: 1, content: "Eat clean and green. Eat Organic." },
    { id: 2, content: "Eat clean and green. Eat Organic." },
    { id: 3, content: "Eat clean and green. Eat Organic." },
    { id: 4, content: "Eat clean and green. Eat Organic." },
  ];

  return (
    <div className="home">
      <div className="home_banner">
        <Swiper
          modules={[Navigation, Autoplay]}
          autoplay={{ delay: 2500, disableOnInteraction: true }}
          loop={true}
          spaceBetween={50}
          slidesPerView={1}
          navigation
        >
          {slides.map((slide) => (
            <SwiperSlide
              key={slide.id}
              className={`banner_slide${slide.id} home_banner_slide flex-center`}
            >
              <div className="slide-content flex-col-center">
                <img
                  className="animate__animated animate__fadeInDown"
                  src="/img/home-banner/organic.webp"
                  alt="home banner"
                />
                <h1 className="dc-script animate__animated animate__fadeInLeft">
                  {slide.content}
                </h1>
                <button className="roboto animate__animated animate__fadeInUp">
                  shop now
                </button>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default BannerSlider;
